<template>
  <div class="icon-picker">
    <Poptip title="请选择图标" placement="bottom" transfer>
      <Button class="open-button">
        <CIcon v-if="value" :icon="value"></CIcon>
        <Icon v-else type="ios-add" :size="30"></Icon>
      </Button>
      <template v-slot:content>
        <div class="icon-list">
          <div
            class="icon-item"
            v-for="item in iconList"
            :key="item"
            @click="onClick(item)"
          >
            <CIcon :icon="item" :size="30"></CIcon>
          </div>
        </div>
      </template>
    </Poptip>
  </div>
</template>
<script>
export default {
  name: 'IconPicker',
  props: ['options', 'value'],
  data() {
    return {
      iconList: this.options
    }
  },
  methods: {
    onClick(item) {
      this.$emit('input', item)
      // 触发iview的formItem校验
      this.$parent.$emit(`on-form-change`)
    }
  }
}
</script>
<style lang="stylus">
.icon-picker
  .open-button
    border-color #d9dbe4
    padding 0
    width 36px
    height 36px
</style>
<style lang="stylus" scoped>
.icon-list
  display flex
  flex-wrap wrap
  justify-content flex-start
  padding-bottom 15px
  width 400px

  .icon-item
    margin 10px
    transition transform 0.3s

    $:hover
      transform scale3d(1.3, 1.3, 1)
</style>